import { styled } from '@creditas/stylitas'
import { ActionLink as CreditasActionLink } from '@creditas/button'

const ActionLink = styled(CreditasActionLink)`
  padding: 0;

  span {
    text-decoration: underline;
  }
`

export { ActionLink }
